module.exports = __webpack_public_path__ + "img/harvest_success.9cde6349.svg";